'use client';

import { LoadingIcon } from '@insta-club/components';
import { useEffect, useRef } from 'react';

interface Props {
    className?: string;
    width?: number;
    height?: number;
    onDisplay: () => void;
}

export const SpinnerObserver: React.FC<Props> = ({ onDisplay, className, width = 20, height = 20 }) => {
    const loaderRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) {
                    onDisplay?.();
                }
            },
            { threshold: 1 }
        );

        if (loaderRef.current) observer.observe(loaderRef.current);

        return () => {
            observer.disconnect();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div ref={loaderRef} className='flex h-14 items-center justify-center'>
            <LoadingIcon width={width} height={height} className={className} />
        </div>
    );
};

export default SpinnerObserver;

